function googlePlaceToLocation(googlePlace) {
  return {
    name: googlePlace.name,
    lat: googlePlace.geometry.location.lat(),
    lng: googlePlace.geometry.location.lng(),
  }
}

export default {
  googlePlaceToLocation,
}



// WEBPACK FOOTER //
// ./src/lib/dataMap.js